import React, {Component} from 'react';
import { Link } from "react-router-dom";
import Skeleton from "../ContentAccordion/ContentAccordion";


class contactFAQButtons extends Component {

    state = {
        categories: this.props.categories,
    };

    getCategories = () => {
        const array =  this.state.categories.categories;
        if(array){
            return array.map((categories) => {
                let url = 'learn/faq?categories=' + categories.category;
                return <Link to={url}  className="faq-link"> <span className="tracking-button__text"> {categories.category}  </span> </Link>
            })
        }else{
            return  <Skeleton type="IFRAME_ERROR"/>

        }



    }

    render() {
        return (
            <div className="faq-div">
                <p>{this.getCategories()}</p>
            </div>
        );
    }
}
export default contactFAQButtons;



// WEBPACK FOOTER //
// ./src/components/ContactFAQs/ContactFAQs.js